import React from 'react';
import parse from 'html-react-parser';


import  searchimg1 from '../assets/images/yachts/image-12.png';
import  searchimg4 from '../assets/images/yachts/image-16.png';
import  searchimg2 from '../assets/images/yachts/image-15.png';
import  searchimg3 from '../assets/images/yachts/image-13.png';
import  searchimg5 from '../assets/images/yachts/image-14.png';
import  searchimg6 from '../assets/images/yachts/image-17.png';
import  cardbg from '../assets/images/icons/card-bg2.png';
import  playicon from '../assets/images/icons/play-icon.png';
import  slider1 from '../assets/images/card/pictures/image-28.png';
import  slider2 from '../assets/images/card/pictures/image-26.png';
import buttonico from '../assets/images/icons/button-arrow.png';
import closearow from '../assets/images/Search/cross.png';
import  vector2 from '../assets/images/icons/card-bg1.png';
import Slider from "react-slick";

function Card(props) {
    let [openMenu,
        setOpenMenu] = React.useState()
    return (
        <div className="row">
            { props.yachts.map((yacht, index) => {
                return [
                    <React.Fragment>
                    <a onClick={() => setOpenMenu(index+1)} className="new_crdnam no-padding col-md-4" href="#colio_c1" style={{display: `block`}}>
                        <div className="design inspiration" data-content="#colio_c1">
                            <div className="thumb">
                                <div className="view">
                                    <a className="button colio-link" href="#colio_c1">
                                        <div className="slider-dark-overlay2"></div>
                                        <img src={yacht.main_image.search_thumb.url ? yacht.main_image.search_thumb.url : searchimg1} alt="Pic"/>
                                    </a>
                                </div>
                            </div>
                            <div className="yachts-destination">
                                <div className="image">
                                    <img src={searchimg4} className="img-responsive"/>
                                </div>
                                <div className="des-details">
                                    <p className="curising">Cruising Regions</p>
                                    <p>{yacht.sailing_countries.map(e => e.name).join(", ")}</p>
                                </div>
                            </div>
                            <div className="yachts-details">
                                <p className="title">{yacht.name}</p>
                                <ul className="yach-details">
                                    <li>{yacht.length} m / {Math.round(yacht.length * 3.28)} ft | {yacht.type ? yacht.type.name : ''} | {yacht.build_year}</li>
                                </ul>
                            </div>
                        </div>
                    </a>
                    { 
                        props.yachts.length === index + 1 ? 
                        
                        [...Array(3-(props.yachts.length % 3 === 0 ? 3 : props.yachts.length % 3))].map((v, i) => {
                            return [
                                <div className="new_crdnam no-padding col-md-4">
                                </div>
                            ]
                        })

                        :
                        false                                 

                    }

                    { ( (index+1) % 3 === 0 && [(((index+1)/3)*3)-2,(((index+1)/3)*3)-1,(((index+1)/3)*3)].includes(openMenu)) ? 
                        <OpenMenu yacht={props.yachts[openMenu-1]} onClose={()=>setOpenMenu(0)}/>
                        : openMenu !== 0 && (index+1) % 3 !== 0 && props.yachts.length === index + 1 && [(((index+1)/3)*3)-2,(((index+1)/3)*3)-1,(((index+1)/3)*3)].includes(openMenu) ?
                        <OpenMenu yacht={props.yachts[openMenu-1]} onClose={()=>setOpenMenu(0)}/>
                        : false

                    }
                    </React.Fragment>
                ]
            })}                                    

        </div>
    );
}
export default Card;
function OpenMenu(props) {
    var settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1
      };
    return (
        <div id="colio_c1" className="colio-container">
            <div className="vector-img">
                <img src={cardbg} className="img-responsive"/>
            </div>
            <div className="container" id="newcon_slider">
                <img className="close_arw" src={closearow} alt="close windos" onClick={props.onClose}></img>
                <div className="row" id="new_frmcrs">
                    <div className="col-md-7 col-sm-12">
                        <div className="pop_mob_search">
                            <h3 >{props.yacht && props.yacht.name}</h3>
                            <p className="main_p_ares">{props.yacht && props.yacht.about && parse(props.yacht.about)}</p>
                        </div>
                        <div className="new_slicksldier">
                            <Slider {...settings} className="slider_slidesnw">
                                { props.yacht && props.yacht.images && props.yacht.images.map((image, index) => {
                                    return [
                                        <div>
                                            <img src={image.search_slider.url} alt="img responsive" />
                                        </div>
                                    ]
                                 })}
                            </Slider>
                        </div>
                    </div>

                    <div className="col-md-5 col-sm-12" id="sldierrightsec">
                        <div className="main">
                            <div className="pop_desktop_search">
                                <h3 className="port_h3nm">{props.yacht.name}</h3>
                                <p className="main_p_ares">{props.yacht && props.yacht.about && parse(props.yacht.about)}</p>
                            </div>
                            <div className="features">
                                <ul className="left">
                                    <li className="builder">
                                        <p className="title">builder:</p>
                                        <p className="desc">{props.yacht.type ? props.yacht.type.name : '' }, {props.yacht.build_year}</p>
                                    </li>
                                    <li className="length">
                                        <p className="title">length:</p>
                                        <p className="desc">{props.yacht.length} m / {Math.round(props.yacht.length * 3.28)} ft</p>
                                    </li>
                                    <li className="crusing">
                                        <p className="title">Cruising regions:</p>
                                        <p className="desc">{props.yacht.sailing_countries.map(e => e.name).join(", ")}</p>
                                    </li>
                                </ul>
                                <ul className="right">
                                    <li className="guest">
                                        <p className="title">guests:</p>
                                        <p className="desc">{ props.yacht.number_of_passengers}</p>
                                    </li>
                                    <li className="cabin">
                                        <p className="title">cabins:</p>
                                        <p className="desc">{ props.yacht.number_of_cabins}</p>
                                    </li>
                                    <li className="crew">
                                        <p className="title">crew:</p>
                                        <p className="desc">{ props.yacht.number_of_members}</p>
                                    </li>
                                </ul>
                            </div>
                            <div className="price-section">
                                { props.yacht.category === "charter" ?
                                    <div className="price-value">
                                    <p>€{props.yacht.charter_price}</p>
                                    <small>P/Week + Expenses</small>
                                    </div>
                                :
                                    <div className="price-value">
                                    <p>€{props.yacht.sale_price}</p>
                                    <small>Listing Price</small>
                                    </div>
                                }
                                
                                <div className="quote-btn">
                                    <a className="btn btn-theme" href={"/yacht/" + props.yacht.id}>
                                        <span>Discover More</span>
                                        <img src={buttonico} className="img-responsive" alt="button icon" />
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="vector-img2">
                <img src={vector2} className="img-responsive" alt="vector" />
            </div>
        </div>
    )
}